/* eslint-disable */
import type { Money } from "../common/currency.pb";

/** A discount applied to a transaction. */
export interface Reward {
  token?: string;
  reward_program_token?: string;
  flat_reward?: RewardFlatRewardTerms | undefined;
  percentage_reward?: RewardPercentageRewardTerms | undefined;
}

export interface RewardFlatRewardTerms {
  reward_amount?: Money;
  minimum_spend_amount?: Money;
}

export interface RewardPercentageRewardTerms {
  reward_basis_points?: number;
}

export interface RewardProgram {
  token?: string;
  description?: string;
  reward?: Reward;
  enabled?: boolean;
  merchant_tokens?: string[];
  parent_merchant_tokens?: string[];
  stored_value_tokens?: string[];
}

/** A customer's request that we investigate why they didn't receive a (coffee, for now) reward. */
export interface MissingRewardReport {
  /** The card transaction the customer expected to be rewarded. */
  transaction_token?: string;
  decision?: MissingRewardReportDecision;
  /** The time the customer sent the report, as a unix time in millis. */
  reported_at?: number;
}

export enum MissingRewardReportDecision {
  /** GRANT - The merchant should have qualified; give the customer the reward. */
  GRANT = "GRANT",
  /** GRANT_ONCE - We don't think the merchant should qualify, but give the customer the reward anyway. */
  GRANT_ONCE = "GRANT_ONCE",
  /** DENY - The merchant should not have qualified; don't give the customer the reward. */
  DENY = "DENY",
}
